export enum URLS {
    TERMS = "https://bbdsoftware.com/disclaimer/",
    PRIVACY_POLICY = "https://bbdsoftware.com/privacy-policy"
}